import React, { useState, useEffect } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../assets/css/style.css";
import NavBar from "../components/navbar/navbar";
import slide1 from "../assets/img/slide1.webp";
import slide2 from "../assets/img/slide2.jpg";
import slide3 from "../assets/img/slide3.webp";
import slide4 from "../assets/img/slide4.jpg";
import HeroCarousel from "../components/HeroCarousel";
import MessageChefDepartement from "../components/MessageChefDepartement";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import mgTranslations from "../locales/mg/common.json";

export default function LandingFepetraPage() {
  const { t } = useTranslation();

  const [expandedCG, setExpandedCG] = useState(null);
  const [expandedML, setExpandedML] = useState(null);

  // Forcer le français sur la page d'accueil
  useEffect(() => {
    i18n.changeLanguage("fr");
  }, []);

  const toggleCardCG = (index) => {
    setExpandedCG(expandedCG === index ? null : index);
  };

  const toggleCardML = (index) => {
    setExpandedML(expandedML === index ? null : index);
  };

  // Slides i18n (alt + caption) — on garde les images locales
  const slides = [
    { src: slide1, alt: t("landing.slides.0.alt"), caption: t("landing.slides.0.caption") },
    { src: slide2, alt: t("landing.slides.1.alt"), caption: t("landing.slides.1.caption") },
    { src: slide3, alt: t("landing.slides.2.alt"), caption: t("landing.slides.2.caption") },
    { src: slide4, alt: t("landing.slides.3.alt"), caption: t("landing.slides.3.caption") },
  ];

  // Cartes "Filoha Mpitarika / Leader" - en malgache
  const cards = mgTranslations.landing.cardsCG;

  // Cartes "Filoha Mpiandraikitra / Manager" - en malgache
  const cards2 = mgTranslations.landing.cardsML;

  return (
    <div>
      <style>{`
        body {
          margin: 0;
          font-family: 'Segoe UI', sans-serif;
          background-color: #e8edf7;
          color: #f8fafc;
        }
        .navbar {
          background-color: #1e293b;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1rem 2rem;
        }
        .navbar a {
          color: #f8fafc;
          text-decoration: none;
          margin-left: 1.5rem;
          font-weight: 500;
        }
        .navbar a:hover {
          color: #38bdf8;
        }
        .logo {
          font-weight: bold;
          font-size: 1.3rem;
          display: flex;
          align-items: center;
        }
        .logo i {
          margin-right: 0.5rem;
          color: #38bdf8;
        }
        .hero {
          text-align: center;
          padding: 4rem 2rem;
        }
        .hero h1 {
          font-size: 2.5rem;
          color: #1e293b;
        }
        .hero p {
          margin-top: 1rem;
          color: #434f5f;
        }
        .btn-main {
          background-color: #0ea5e9;
          color: white;
          padding: 0.75rem 2rem;
          margin-top: 2rem;
          border: none;
          border-radius: 25px;
          font-weight: bold;
          cursor: pointer;
        }
        .section {
          padding: 2rem;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 2rem;
        }
        .card {
          background-color: #1e293b;
          border-radius: 10px;
          padding: 1.5rem;
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          transition: transform 0.3s;
        }
        .card:hover {
          transform: scale(1.02);
        }
        .card-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.2rem;
          font-weight: bold;
          margin-bottom: 1rem;
          color:white;
        }
        .card-header i {
          color: #38bdf8;
          margin-right: 0.5rem;
        }
        .card ul {
          list-style: none;
          padding-left: 1rem;
        }
        li {
          color: white;
        }
        .colorli { color: white; }
        .colorh5 { color: white; }
        .colorbtn { background: #0ea5e9; color: white; }
        .cardstyle { background: #1e293b; }
      `}</style>

      <NavBar />

      <div className="hero">
        <HeroCarousel height={460} interval={5500} slides={slides} />
        <div className="mt-5">
          <h1>{mgTranslations.landing.hero.titleCG}</h1>
          <p>{mgTranslations.landing.hero.subtitleCG}</p>
        </div>
      </div>

      {/* Section CG */}
      <div className="container">
        <div className="row">
          {Array.isArray(cards) && cards.map((card, index) => (
            <div className="col-md-6 col-lg-6 mb-4 colorli" key={`cg-${index}`}>
              <div className="card cardstyle text-white shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3 colorli">
                    <h5 className="card-title1 colorh5">
                      {card.title}
                    </h5>
                    <button
                      className="btn colorbtn btn-sm"
                      onClick={() => toggleCardCG(index)}
                      aria-expanded={expandedCG === index}
                      aria-controls={`cg-panel-${index} colorli`}
                    >
                      {expandedCG === index ? (
                        <><i className="bi bi-eye colorli"></i> {t("landing.less")}</>
                      ) : (
                        <><i className="bi bi-eye colorli"></i> {t("landing.more")}</>
                      )}
                    </button>
                  </div>

                  {expandedCG === index && (
                    <ul id={`cg-panel-${index}`} className="list-unstyled colorli">
                      {card.items.map((item, idx) => (
                        <li key={`cg-item-${index}-${idx}`} className="mb-2 colorli">
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="hero">
        <h1>{mgTranslations.landing.hero.titleML}</h1>
        <p>{mgTranslations.landing.hero.subtitleML}</p>
      </div>

      {/* Section ML */}
      <div className="container">
        <div className="row">
          {Array.isArray(cards2) && cards2.map((card2, index) => (
            <div className="col-md-6 col-lg-6 mb-4" key={`ml-${index}`}>
              <div className="card text-white shadow-sm h-100">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title1">
                      {card2.title}
                    </h5>
                    <button
                      className="btn btn-sm btn-outline-light"
                      onClick={() => toggleCardML(index)}
                      aria-expanded={expandedML === index}
                      aria-controls={`ml-panel-${index}`}
                    >
                      {expandedML === index ? (
                        <><i className="bi bi-eye-slash"></i> {t("landing.less")}</>
                      ) : (
                        <><i className="bi bi-eye"></i> {t("landing.more")}</>
                      )}
                    </button>
                  </div>

                  {expandedML === index && (
                    <ul id={`ml-panel-${index}`} className="list-unstyled">
                      {card2.items.map((item, idx) => (
                        <li key={`ml-item-${index}-${idx}`} className="mb-2">
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Message du Chef de Département */}
      <div className="container my-5">
        <MessageChefDepartement />
      </div>

    </div>
  );
}
